import type { ISpectralDiagnostic } from '@stoplight/spectral-core'
import { bundleAndLoadRuleset } from '@stoplight/spectral-ruleset-bundler/with-loader'

export async function loadRuleset(ruleset: string) {
  return await bundleAndLoadRuleset('/.spectral.yaml', {
    fs: {
      promises: {
        // @ts-expect-error No need for overloading here.
        async readFile(_filepath) {
          return ruleset
        },
      },
    },
    format: 'esm',
  })
}

export const defaultRuleset = `extends: spectral:oas
rules: {}`

export const severityToLabel = (severity: ISpectralDiagnostic['severity']) => {
  return (
    {
      0: 'Error',
      1: 'Warning',
      2: 'Information',
      3: 'Hint',
    } as const satisfies Record<ISpectralDiagnostic['severity'], string>
  )[severity]
}
